import embed from "./embed.vue";
export default embed;
